module.exports = __webpack_public_path__ + "img/illyes_barbi.053d35f8.jpg";